import { authApi } from './auth';
import { stationApi } from './stations';
import { flagBagApi } from './flagbags';
import { OfflineData, UpdateFlagBagRequest } from './flagbags/types';

export { authApi } from './auth';
export { stationApi } from './stations';
export { flagBagApi } from './flagbags';
export { VolunteerApi } from './volunteer';

export { ErrorCodes, ErrorMessages, isErrorResponse } from './constants';
export type { ApiResponse, ApiError, RequestConfig, IResponse } from './types';

export { httpClient } from './client';

export type { Account, EventData } from './auth/types';
export type { StationData, BankQuotaResponse, StationDetail } from './stations/types';
export type {
  FlagBag,
  FlagBagStatus,
  FlagBagStatusResponse,
  OfflineData,
  FlagbagFilterStatus,
  StatusCode,
} from './flagbags/types';
export type { VolunteerData, GetVolunteerResponse } from './volunteer/types';
export {
  FilterStatusLabel,
  StatusLabel,
  StatusValue,
} from './flagbags/types';

export const checkConnection = () => authApi.checkConnection();

export const login = (eventId: string, email: string, password: string) =>
  authApi.login(eventId, email, password);

export const logout = () => authApi.logout();

export const getStationList = (eventID: string) => stationApi.getList(eventID);

export const getStationDetail = (stationID: string, eventID: string, decrypted: boolean) =>
  stationApi.getDetail(stationID, eventID, decrypted);

export const getFlagBagFromStation = (eventId: string, stationId: string) =>
  flagBagApi.getFlagBagList(eventId, stationId, 1, 9000);

export const getGroupList = (stationID: string) =>
  stationApi.getGroups(stationID);

export const flushOfflineDataApi = (
  stationID: string,
  data: OfflineData[],
  timestamp: number
) => flagBagApi.flushOfflineData(stationID, data, timestamp);

export const getFlagBagStatus = (flagBagID: string, stationID: string) =>
  flagBagApi.getStatus(flagBagID, stationID);

export const CheckOutSpareFlagBag = (
  stationID: string,
  flagBagID: string,
  name: string,
  phone: string,
) => flagBagApi.checkOutSpare(stationID, flagBagID, name, phone);

export const getNumOfRemainedBankQuota = (eventID: string, stationID: string) =>
  stationApi.getBankQuota(eventID, stationID);

export const updateSignleFlagBag = (
  flagBagId: string,
  eventId: string,
  stationID: string,
  payload: UpdateFlagBagRequest
) => flagBagApi.updateSingle(flagBagId, eventId, stationID, payload);

export const getStationOverview = (eventID: string) =>
  stationApi.getOverview(eventID);

export type { ApiResponse as ApiReturn } from './types';
